import React from 'react';
import { FAQs } from './FAQs';
import FingerPrintImg from 'assets/your-security.png';
import FAQBg from 'assets/faq-bg.png';

export const SecurityFAQs = () => {
  return (
    <div
      className="w-full bg-cover bg-center py-12 px-6 md:px-16 rounded-3xl"
      style={{ backgroundImage: `url(${FAQBg})` }}
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between">
        {/* Left Section - Security Info */}
        <div className="md:w-1/2 text-left text-white">
          <h2 className="text-3xl md:text-6xl font-black mb-4">
            Your Security is Our Top Priority
          </h2>
          <p className="text-lg md:text-xl">
            We use state-of-the-art encryption to keep your personal information safe. Wire24
            complies with global financial regulations, giving you peace of mind with every
            transaction.
          </p>
        </div>

        {/* Right Section - Fingerprint Image */}
        <div className="md:w-1/2 flex justify-end">
          <img
            src={FingerPrintImg}
            alt="Fingerprint Security"
            className="w-48 md:w-[25vw] md:-mt-48"
          />
        </div>
      </div>

      {/* FAQs Section */}
      <div className="mt-12">
        <FAQs />
      </div>
    </div>
  );
};
